module.exports = __webpack_public_path__ + "img/thanos.3df45852.png";